import React, { useRef } from 'react';
import Paper from '@mui/material/Paper';
import { motion, useAnimation, useInView } from 'framer-motion';
import skillReport from '../../../images/skill_Report.png';
import certification from '../../../images/certification.png';
import resultIcon from '../../../images/Result.png';
import interviewIcon from '../../../images/Interview.png';
import passportIcon from '../../../images/Passport.png';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export default function Steps() {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm')); // true for mobile/tablet
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const controls = useAnimation();

  if (isInView) {
    controls.start({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: 'easeOut' }
    });
  }

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 100 }}
      animate={controls}
      style={{
        marginTop: '10%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: matches ? 'center' : 'flex-start',
        flexWrap: matches ? 'nowrap' : 'wrap',
        flexDirection: matches ? 'column' : 'row',
        gap: matches ? '40px' : '0px',  // Adjust gap for mobile vs desktop
        padding: '0 16px',
        position: 'relative',
      }}
    >
      {/* Vertical line for mobile only */}
      {matches && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            width: '4px',
            // height: '70%',
            backgroundColor: '#C4C4C4',
            zIndex: 0,
          }}
        />
      )}

      {/* Step 1 */}
      <div
        style={{
          position: 'relative',
          textAlign: 'center',
          width: matches ? '180px' : '250px',
          maxWidth: '100%',
          marginBottom: matches ? '0px' : '20px',
          zIndex: 1,
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: matches ? 50 : -120,
            left:matches?'-40%':'50%',
            transform: 'translateX(-50%)',
            color: '#FF00FF',
            fontWeight: 'bold',
            fontSize: matches ? '8vw' : '4vw',
          }}
        >
          1
        </div>
        <div
          style={{
            position: 'absolute',
            top: matches ? -40 : -60,
            left: '50%',
            transform: 'translateX(-50%)',
            width: 0,
            height: 40,
            borderLeft:matches?'': '4px dashed #C4C4C4',
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: matches ? -10 : -16,
            left: '50%',
            transform: 'translateX(-50%)',
            width: matches ? 180 : 250,
            height: matches ? 90 : 125,
             borderTop:matches?'': '4px dashed #C4C4C4',
            borderRadius: '125px 125px 0 0',
          }}
        />
        <motion.div
          whileHover={{
            scale: 1.05,
            borderRadius: '50%',
            boxShadow: '0 0 20px 10px rgba(255, 0, 255, 0.6)',
          }}
          transition={{ type: 'spring', stiffness: 100 }}
        >
          <Paper
            elevation={10}
            style={{
              width: matches ? 180 : 250,
              height: matches ? 180 : 250,
              backgroundColor: '#F48A27',
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              boxShadow: '0 0 20px 0 rgba(255, 0, 255, 0.4)',
            }}
          >
            <img src={skillReport} alt="Skillsphere Report" style={{ width: '50%', height: '50%' }} />
          </Paper>
        </motion.div>
        <div
          style={{
            position: 'absolute',
            top: matches ? 190 : 260,
            left: '50%',
            transform: 'translateX(-50%)',
            width: 30,
            height: 30,
            borderLeft: '15px solid transparent',
            borderRight: '15px solid transparent',
            borderTop:matches?'': '15px solid #BDBDBD',
          }}
        />
        <div
          style={{
            marginTop: matches ? 20 : 30,
            fontFamily: 'Poppins',
            fontSize: matches ? '4vw' : '24px',
            fontWeight: '700',
            
            width: 180,
            marginLeft: matches ? '0px' : '40px',
          }}
        >
          Skillsphere Report
        </div>
      </div>

      {/* Step 2 */}
      <div
        style={{
          position: 'relative',
          textAlign: 'center',
          width: matches ? '180px' : '250px',
          maxWidth: '100%',
          marginBottom: matches ? '40px' : '20px',
          zIndex: 1,
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: matches ? 50 : 300,
            left:matches?'-35%':'50%',
            transform: 'translateX(-50%)',
            color: '#FF00FF',
            fontWeight: 'bold',
            fontSize: matches ? '8vw' : '4vw',
          }}
        >
          2
        </div>
        <div
          style={{
            position: 'absolute',
            top: matches ? 190 : 270,
            left: '50%',
            transform: 'translateX(-50%)',
            width: 0,
            height: 40,
             borderLeft:matches?'': '4px dashed #C4C4C4',
          }}
        />
        <div
  style={{
    position: 'absolute',
    bottom: matches ? -10 : -16, // top ke jagah bottom
    left: '50%',
    transform: 'translateX(-50%)',
    width: matches ? 180 : 250,
    height: matches ? 90 : 125,
    borderBottom: matches ? '' : '4px dashed #C4C4C4', // borderTop -> borderBottom
    borderRadius: '0 0 125px 125px', // borderRadius ulta
  }}
/>

        
        <div
          style={{
            position: 'absolute',
            top: matches ? 190 : -100,
            left: '50%',
            transform: 'translateX(-50%)',
            fontWeight: '700',
            fontFamily: 'Poppins',
            fontSize: matches ? '4vw' : '24px',
            width: 290,
          }}
        >
          NextGen Innovators Completion Certificate
        </div>
        <div
  style={{
    position: 'absolute',
    top: matches ? 190 : -25,
    left: '50%',
    transform: 'translateX(-50%)',
    width: 0,
    height: 0,
    borderLeft: '15px solid transparent',
    borderRight: '15px solid transparent',
    borderBottom: matches ? '' : '15px solid #BDBDBD',
  }}
/>

        <motion.div
          whileHover={{
            scale: 1.05,
            borderRadius: '50%',
            boxShadow: '0 0 50px 10px rgba(255, 0, 255, 0.6)',
          }}
          transition={{ type: 'spring', stiffness: 100 }}
        >
          <Paper
            elevation={10}
            style={{
              width: matches ? 180 : 250,
              height: matches ? 180 : 250,
              backgroundColor: '#FFFFFF',
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img src={certification} alt="NextGen Innovators Completion Certificate" style={{ width: '50%', height: '50%' }} />
          </Paper>
          
        </motion.div>
      </div>

      {/* Step 3 */}
      <div
        style={{
          position: 'relative',
          textAlign: 'center',
          width: matches ? '180px' : '250px',
          maxWidth: '100%',
          marginBottom: matches ? '0px' : '20px',
          zIndex: 1,
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: matches ? 50 : -120,
            left:matches?'-35%':'50%',
            transform: 'translateX(-50%)',
            color: '#FF00FF',
            fontWeight: 'bold',
            fontSize: matches ? '8vw' : '4vw',
          }}
        >
          3
        </div>
        <div
          style={{
            position: 'absolute',
            top: matches ? -40 : -60,
            left: '50%',
            transform: 'translateX(-50%)',
            width: 0,
            height: 40,
         borderLeft:matches?'': '4px dashed #C4C4C4',
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: matches ? -10 : -16,
            left: '50%',
            transform: 'translateX(-50%)',
            width: matches ? 180 : 250,
            height: matches ? 90 : 125,
             borderTop:matches?'': '4px dashed #C4C4C4',
            borderRadius: '125px 125px 0 0',
          }}
        />
        <motion.div
          whileHover={{
            scale: 1.05,
            borderRadius: '50%',
            boxShadow: '0 0 50px 10px rgba(255, 0, 255, 0.6)',
          }}
          transition={{ type: 'spring', stiffness: 100 }}
        >
          <Paper
            elevation={10}
            style={{
              width: matches ? 180 : 250,
              height: matches ? 180 : 250,
              backgroundColor: '#F48A27',
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img src={resultIcon} alt="Skills Based Test Result" style={{ width: '50%', height: '50%' }} />
          </Paper>
        </motion.div>
        <div
          style={{
            position: 'absolute',
            top: matches ? 190 : 260,
            left: '50%',
            transform: 'translateX(-50%)',
            width: 30,
            height: 30,
            borderLeft: '15px solid transparent',
            borderRight: '15px solid transparent',
            borderTop:matches?'': '15px solid #BDBDBD',
          }}
        />
        <div
          style={{
            marginTop: matches ? 20 : 30,
            fontFamily: 'Poppins',
            fontSize: matches ? '4vw' : '24px',
            fontWeight: '700',
            width: 180,
            marginLeft: matches ? '0px' : '40px',
          }}
        >
          Skills Based Test Result
        </div>
      </div>

      {/* Step 4 */}
      <div
        style={{
          position: 'relative',
          textAlign: 'center',
          width: matches ? '180px' : '250px',
          maxWidth: '100%',
          marginBottom: matches ? '40px' : '20px',
          zIndex: 1,
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: matches ? 55 : 300,
            left:matches?'-35%': '50%',
            transform: 'translateX(-50%)',
            color: '#FF00FF',
            fontWeight: 'bold',
            fontSize: matches ? '8vw' : '4vw',
          }}
        >
          4
        </div>
        <div
          style={{
            position: 'absolute',
            top: matches ? 190 : 270,
            left: '50%',
            transform: 'translateX(-50%)',
            width: 0,
            height: 40,
             borderLeft:matches?'': '4px dashed #C4C4C4',
          }}
        />
         <div
  style={{
    position: 'absolute',
    bottom: matches ? -10 : -16, // top ke jagah bottom
    left: '50%',
    transform: 'translateX(-50%)',
    width: matches ? 180 : 250,
    height: matches ? 90 : 125,
    borderBottom: matches ? '' : '4px dashed #C4C4C4', // borderTop -> borderBottom
    borderRadius: '0 0 125px 125px', // borderRadius ulta
  }}
/>
        <div
          style={{
            position: 'absolute',
            top: matches ? 200 : -70,
            left: '50%',

            transform: 'translateX(-50%)',
            fontFamily: 'Poppins',
            fontSize: matches ? '4vw' : '24px',
            fontWeight: '700',
            width: 290,
          }}
        >
          Interview Result
        </div>
        <div
  style={{
    position: 'absolute',
    top: matches ? 190 : -25,
    left: '50%',
    transform: 'translateX(-50%)',
    width: 0,
    height: 0,
    borderLeft: '15px solid transparent',
    borderRight: '15px solid transparent',
    borderBottom: matches ? '' : '15px solid #BDBDBD',
  }}
/>
        <motion.div
          whileHover={{
            scale: 1.05,
            borderRadius: '50%',
            boxShadow: '0 0 50px 10px rgba(255, 0, 255, 0.6)',
          }}
          transition={{ type: 'spring', stiffness: 100 }}
        >
          <Paper
            elevation={10}
            style={{
              width: matches ? 180 : 250,
              height: matches ? 180 : 250,
              backgroundColor: '#FFFFFF',
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img src={interviewIcon} alt="Interview Result" style={{ width: '50%', height: '50%' }} />
          </Paper>
        </motion.div>
      </div>

      {/* Step 5 */}
      <div
        style={{
          position: 'relative',
          textAlign: 'center',
          width: matches ? '180px' : '250px',
          maxWidth: '100%',
          zIndex: 1,
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: matches ? 50 : -120,
            left:matches?'-35%': '50%',
            transform: 'translateX(-50%)',
            color: '#FF00FF',
            fontWeight: 'bold',
            fontSize: matches ? '8vw' : '4vw',
          }}
        >
          5
        </div>
        <div
          style={{
            position: 'absolute',
            top: matches ? -40 : -60,
            left: '50%',
            transform: 'translateX(-50%)',
            width: 0,
            height: 40,
            borderLeft:matches?'': '4px dashed #C4C4C4',
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: matches ? -10 : -16,
            left: '50%',
            transform: 'translateX(-50%)',
            width: matches ? 180 : 250,
            height: matches ? 90 : 125,
             borderTop:matches?'': '4px dashed #C4C4C4',
            borderRadius: '125px 125px 0 0',
          }}
        />
        <motion.div
          whileHover={{
            scale: 1.05,
            borderRadius: '50%',
            boxShadow: '0 0 50px 10px rgba(255, 0, 255, 0.6)',
          }}
          transition={{ type: 'spring', stiffness: 100 }}
        >
          <Paper
            elevation={10}
            style={{
              width: matches ? 180 : 250,
              height: matches ? 180 : 250,
              backgroundColor: '#F48A27',
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img src={passportIcon} alt="Passport Icon" style={{ width: '50%', height: '50%' }} />
          </Paper>
        </motion.div>
        <div
          style={{
            position: 'absolute',
            top: matches ? 190 : 260,
            left: '50%',
            transform: 'translateX(-50%)',
            width: 30,
            height: 30,
            borderLeft: '15px solid transparent',
            borderRight: '15px solid transparent',
            borderTop:matches?'': '15px solid #BDBDBD',
          }}
        />
        <div
          style={{
            marginTop: matches ? 20 : 30,
            fontFamily: 'Poppins',
            fontSize: matches ? '4vw' : '24px',
            fontWeight: '700',
            width: 180,
            marginLeft: matches ? '0px' : '40px',
          }}
        >
          Passport Ready
        </div>
      </div>
    </motion.div>
  );
}